import { render } from "./SaoKeComponent.vue?vue&type=template&id=07b88c98&scoped=true"
import script from "./SaoKeComponent.vue?vue&type=script&lang=js"
export * from "./SaoKeComponent.vue?vue&type=script&lang=js"

import "./SaoKeComponent.vue?vue&type=style&index=0&id=07b88c98&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b88c98"]])

export default __exports__